export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_SUMMARY = 'UPDATE_PROFILE_SUMMARY';
export const UPDATE_PROFILE_VIDEO = 'UPDATE_PROFILE_VIDEO';
export const UPDATE_PROFILE_HEADER_BACKGROUND_COLOR =
  'UPDATE_PROFILE_HEADER_BACKGROUND_COLOR';
export const UPDATE_PROFILE_STATUS = 'UPDATE_PROFILE_STATUS';

export const UPDATE_PROFILE_COURSES = 'UPDATE_PROFILE_COURSES';
export const UPDATE_PROFILE_COURSES_STATUS = 'UPDATE_PROFILE_COURSES_STATUS';

export const UPDATE_PROFILE_BADGES = 'UPDATE_PROFILE_BADGES';
export const UPDATE_PROFILE_BADGES_STATUS = 'UPDATE_PROFILE_BADGES_STATUS';

export const UPDATE_PROFILE_CERTIFICATES = 'UPDATE_PROFILE_CERTIFICATES';
export const UPDATE_PROFILE_CERTIFICATES_STATUS =
  'UPDATE_PROFILE_CERTIFICATES_STATUS';

export const UPDATE_PROFILE_PORTFOLIO_STATUS =
  'UPDATE_PROFILE_PORTFOLIO_STATUS';

export const UPDATE_PROFILE_USER_EDUCATION_EXPERIENCE =
  'UPDATE_PROFILE_USER_EDUCATION_EXPERIENCE';
export const UPDATE_PROFILE_USER_WORK_EXPERIENCE =
  'UPDATE_PROFILE_USER_WORK_EXPERIENCE';
export const UPDATE_PROFILE_USER_EDUCATION_EXPERIENCE_STATUS =
  'UPDATE_PROFILE_USER_EDUCATION_EXPERIENCE_STATUS';
export const UPDATE_PROFILE_USER_WORK_EXPERIENCE_STATUS =
  'UPDATE_PROFILE_USER_WORK_EXPERIENCE_STATUS';
export const SET_PROFILE_USER_EDUCATION_EXPERIENCES =
  'SET_PROFILE_USER_EDUCATION_EXPERIENCES';
export const SET_PROFILE_USER_WORK_EXPERIENCES =
  'SET_PROFILE_USER_WORK_EXPERIENCES';
